import { Typography } from "components/atoms";
import React, { useState, DragEvent, useEffect } from "react";

interface IProps {
  value: string;
  onChange: (e: any) => void;
}

export const UploadInput = ({ value, onChange }: IProps) => {
  const [files, setFiles] = useState<File[]>([]);
  const maxFiles = 3;
  
  const handleDragOver = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    event.currentTarget.classList.add("drag-over");
  };

  const handleDragLeave = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    event.currentTarget.classList.remove("drag-over");
  };

  const handleDrop = (event: DragEvent<HTMLDivElement>) => {
    event.preventDefault();
    event.stopPropagation();
    event.currentTarget.classList.remove("drag-over");

    const droppedFiles = Array.from(event.dataTransfer.files);
    const validFiles = filterValidFiles(droppedFiles);
    addFiles(validFiles);
  };

  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = event.target.files
      ? Array.from(event.target.files)
      : [];
    const validFiles = filterValidFiles(selectedFiles);
    addFiles(validFiles);
    event.target.value = "";
  };

  const filterValidFiles = (fileList: File[]) => {
    return fileList.filter(
      (file) =>
        file.type === "application/pdf" ||
        file.type === "image/png" ||
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/tif" ||
        file.type === "image/tiff" ||
        file.type === "image/bmp"
    );
  };

  const addFiles = (newFiles: File[]) => {
    const totalFiles = files.length + newFiles.length;
    if (totalFiles > maxFiles) {
      return;
    }
    setFiles((prevFiles) => [...prevFiles, ...newFiles]);
  };

  const openFileDialog = () => {
    document.getElementById("fileInput")?.click();
  };

  const handleFileRemove = (index: number) => {
    setFiles((prevFiles) => prevFiles.filter((_, i) => i !== index));
  };

  useEffect(() => {
    onChange(files);
  }, [files]);

  return (
    <div className="onb-form-upload-container">
      <div className="file-upload">
        <div
          className="drop-zone"
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
        >
          <Typography
            label="Drop files to upload"
            variant="h6Book"
            styles="drop-files-text-custom-style"
          />
          <Typography
            label="or"
            variant="h6Book"
            styles="or-text-custom-style"
          />
          <button
            className="select-files-btn-style"
            onClick={openFileDialog}
            disabled={files.length >= 3}
          >
            Select Files
          </button>
          <Typography
            label={`[Max: 3]`}
            variant="h6Book"
            styles="max-count-custom-style"
          />
        </div>
        <input
          id="fileInput"
          type="file"
          multiple
          accept=".pdf, .png, .jpeg"
          style={{ display: "none" }}
          onChange={handleFileSelect}
        />
        <div className="selected-files-list">
          {files.map((file, index) => (
            <div className="selected-file-wrapper" key={index}>
              <Typography
                key={`${index}-file-name`}
                label={file.name}
                variant="h6Book"
                styles="selected-file-name-cutom-style"
              />
              <Typography
                key={`${index}-remove`}
                label="Remove"
                variant="h6Book"
                styles="selcted-file-remove-style"
                onClick={() => handleFileRemove(index)}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
